import { render, staticRenderFns } from "./SpecimenChickenPlate.vue?vue&type=template&id=0ed92c80&scoped=true"
import script from "./SpecimenChickenPlate.vue?vue&type=script&lang=js"
export * from "./SpecimenChickenPlate.vue?vue&type=script&lang=js"
import style0 from "./SpecimenChickenPlate.vue?vue&type=style&index=0&id=0ed92c80&prod&lang=scss&scoped=true"
import style1 from "./SpecimenChickenPlate.vue?vue&type=style&index=1&id=0ed92c80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed92c80",
  null
  
)

export default component.exports